<template>
  <ValidateAll ref="header">
    <v-row v-if="!terkunci">
      <v-col cols="6">
        <div class="headline mt-2">{{title()}}</div>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          color="warning"
          outlined
          large
          class="mr-2"
          @click="clearDetailCacheWithConfirm"
          v-if="cacheExists"
        >
          <span class="hidden-xs-only">Bersihkan Cache</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-delete-outline</v-icon>
        </v-btn>
        <v-btn color="primary" large @click="save" :loading="saving">
          <span class="hidden-xs-only">Simpan</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-content-save-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row :dense="$vuetify.breakpoint.xsOnly">
      <!-- Header -->
      <v-col cols="12" md="3">
        <v-card class="card-summary">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-bag-personal</v-icon>Sekolah
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isSekolahEmpty || isEditingSekolah) && !terkunci && !saving && !$acl.check('isSekolah')"
              @click="isEditingSekolah = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <Validate
                class="w-100"
                name="Sekolah"
                rules="fully_required"
                #default="{ errors }"
                v-if="isEditingSekolah"
              >
                <v-autocomplete
                  :error-messages="errors"
                  class="mb-1 mt-1"
                  v-model="header.Sekolah"
                  :loading="list.isSekolahLoading"
                  :items="list.sekolah.data"
                  name="Sekolah"
                  placeholder="Pilih Sekolah"
                  item-text="Nama"
                  item-value="IDSekolah"
                  dense
                  hide-no-data
                  return-object
                >
                  <!-- button slot -->
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      :disabled="isSekolahEmpty"
                      :color="isSekolahEmpty ? 'disabled' : 'success'"
                      @click="isEditingSekolah = !isEditingSekolah"
                    >
                      <v-icon>mdi-check-outline</v-icon>
                    </v-btn>
                  </template>
                  <!-- selected slot -->
                  <template v-slot:selection="data">
                    <v-list-item-title>
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Kode}}</span>
                    </v-list-item-title>
                  </template>
                  <!-- list item slot -->
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title class="py-0">
                          {{data.item.Nama}}
                          &mdash;
                          <span
                            class="text--secondary"
                          >{{data.item.Kode}}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.Alamat}} {{ data.item.Lokasi}} {{data.item.Provinsi}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </Validate>
              <v-list-item-content v-if="!isSekolahEmpty && !isEditingSekolah">
                <v-list-item-title class="title">{{header.Sekolah.Nama}}</v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text--primary">{{header.Sekolah.Kode}}</span>
                  &mdash;
                  {{header.Sekolah.Alamat}} {{header.Sekolah.Lokasi}} {{header.Sekolah.Provinsi}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="card-summary">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-briefcase-account-outline</v-icon>Pejabat Sekolah
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isPejabatSekolahEmpty || isEditingPejabatSekolah) && !terkunci && !saving"
              @click="isEditingPejabatSekolah = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <Validate
                class="w-100"
                name="Pejabat sekolah"
                rules="fully_required"
                #default="{ errors }"
                v-if="isEditingPejabatSekolah"
              >
                <v-autocomplete
                  :error-messages="errors"
                  class="mb-1 mt-1"
                  v-model="header.PejabatSekolah"
                  :loading="list.isPejabatLoading"
                  :items="list.pejabat.data"
                  name="PejabatSekolah"
                  :placeholder="isSekolahEmpty ? 'Pilih Sekolah Terlebih Dahulu':'Pilih Pejabat'"
                  item-text="Nama"
                  item-value="IDPejabat"
                  :disabled="isSekolahEmpty"
                  dense
                  hide-no-data
                  return-object
                >
                  <!-- button slot -->
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      :disabled="isPejabatSekolahEmpty"
                      :color="isPejabatSekolahEmpty ? 'disabled' : 'success'"
                      @click="isEditingPejabatSekolah = !isEditingPejabatSekolah"
                    >
                      <v-icon>mdi-check-outline</v-icon>
                    </v-btn>
                  </template>
                  <!-- selected slot -->
                  <template v-slot:selection="data">
                    <v-list-item-title>
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Jabatan}}</span>
                    </v-list-item-title>
                  </template>
                  <!-- list item slot -->
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title class="py-0">{{data.item.Nama}}</v-list-item-title>
                        <v-list-item-subtitle>
                          <span class="text--secondary">{{data.item.Jabatan}}</span>
                          &mdash; {{ data.item.NIP}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </Validate>
              <v-list-item-content v-if="!isPejabatSekolahEmpty && !isEditingPejabatSekolah">
                <v-list-item-title class="title">{{header.PejabatSekolah.Nama}}</v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text--primary">{{header.PejabatSekolah.Jabatan}}</span>
                  &mdash;
                  {{header.PejabatSekolah.NIP}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card class="card-summary">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-calendar</v-icon>Tahun
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isTahunEmpty || isEditingTahun) && !terkunci && !saving"
              @click="isEditingTahun = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <Validate
                class="w-100"
                name="Tahun"
                rules="required"
                #default="{ errors }"
                v-if="isEditingTahun"
              >
                <v-autocomplete
                  :error-messages="errors"
                  class="mb-1 mt-1"
                  v-model="header.Tahun"
                  :loading="list.isTahunLoading"
                  :items="list.tahun.data"
                  name="Tahun"
                  placeholder="Pilih Tahun"
                  item-text="Tahun"
                  item-value="Tahun"
                  dense
                  hide-no-data
                >
                  <!-- button slot -->
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      :disabled="isTahunEmpty"
                      :color="isTahunEmpty ? 'disabled' : 'success'"
                      @click="isEditingTahun = !isEditingTahun"
                    >
                      <v-icon>mdi-check-outline</v-icon>
                    </v-btn>
                  </template>
                </v-autocomplete>
              </Validate>
              <v-list-item-content v-if="!isTahunEmpty && !isEditingTahun">
                <v-list-item-title class="title">{{header.Tahun}}</v-list-item-title>
                <!-- <v-list-item-subtitle>
                  <span class="text--primary">{{header.Tahun.Kode}}</span>
                </v-list-item-subtitle>-->
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>

      <v-col cols="6" md="3">
        <v-card class="card-summary">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi-label-variant-outline</v-icon>Status Anggaran
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isStatusAnggaranEmpty || isEditingStatusAnggaran) && !terkunci && !saving"
              @click="isEditingStatusAnggaran = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <Validate
                class="w-100"
                name="Status anggaran"
                rules="required"
                #default="{ errors }"
                v-if="isEditingStatusAnggaran"
              >
                <v-autocomplete
                  :error-messages="errors"
                  class="mb-1 mt-1"
                  v-model="header.StatusAnggaran"
                  :loading="list.isStatusAnggaranLoading"
                  :items="list.statusAnggaran.data"
                  name="StatusAnggaran"
                  :disabled="isTahunEmpty"
                  :placeholder="isTahunEmpty?'Pilih Tahun Terlebih Dahulu':'Pilih Status Anggaran'"
                  item-text="StatusAnggaran"
                  item-value="StatusAnggaran"
                  dense
                  hide-no-data
                >
                  <!-- button slot -->
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      :disabled="isStatusAnggaranEmpty"
                      :color="isStatusAnggaranEmpty ? 'disabled' : 'success'"
                      @click="isEditingStatusAnggaran = !isEditingStatusAnggaran"
                    >
                      <v-icon>mdi-check-outline</v-icon>
                    </v-btn>
                  </template>
                </v-autocomplete>
              </Validate>
              <v-list-item-content v-if="!isStatusAnggaranEmpty && !isEditingStatusAnggaran">
                <v-list-item-title class="title">{{header.StatusAnggaran}}</v-list-item-title>
                <!-- <v-list-item-subtitle>
                  <span class="text--primary">{{header.StatusAnggaran.Kode}}</span>
                </v-list-item-subtitle>-->
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card class="card-summary">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-wallet</v-icon>Penerimaan
            </div>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="title">{{totalPenerimaan | currency}}</v-list-item-title>
                <v-list-item-subtitle v-if="lastUpdatedDatePenerimaan">
                  <span class="hidden-sm-and-down">
                    Terakhir berubah
                    &mdash;
                  </span>
                  {{lastUpdatedDatePenerimaan | dateRelative}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="card-summary">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-cart</v-icon>Belanja
            </div>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="title">{{totalBelanja | currency}}</v-list-item-title>
                <v-list-item-subtitle v-if="lastUpdatedDateBelanja">
                  <span class="hidden-sm-and-down">
                    Terakhir berubah
                    &mdash;
                  </span>
                  {{lastUpdatedDateBelanja | dateRelative}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>

      <!-- Details -->
      <v-col cols="12">
        <v-card>
          <v-card-subtitle class="pb-0">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-table</v-icon>Rincian
            </div>
          </v-card-subtitle>
          <v-card-text>
            <v-skeleton-loader :loading="loading" type="table">
              <rincian-anggaran v-model="details" :disabled="terkunci || isSekolahEmpty || saving"></rincian-anggaran>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </ValidateAll>
</template>

<script>
import sumBy from "lodash/sumBy";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    RincianAnggaran: () =>
      import(
        /* webpackChunkName: "RincianAnggaran" */ "@/components/RincianAnggaran.vue"
      )
  },
  data: () => ({
    saving: false,
    loading: false,
    header: {
      Nomor: "",
      Tanggal: new Date().toISOString().substr(0, 10),
      Keterangan: "",
      IDSekolah: "",
      Sekolah: {},
      Tahun: null,
      StatusAnggaran: "",
      IDPejabatSekolah: "",
      PejabatSekolah: {}
    },
    details: [],
    pajak: [],
    modalDatepicker: false,
    isEditingSekolah: false,
    isEditingRekening: false,
    isEditingTahun: false,
    isEditingStatusAnggaran: false,
    isEditingPejabatSekolah: false,
    Keyword: "",
    cacheExists: false,
    disabledSimpan: true
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isSekolahLoading",
      "isRekeningLoading",
      "isTahunLoading",
      "isStatusAnggaranLoading",
      "isPejabatLoading"
    ]),
    isSekolahEmpty() {
      return this.$util.isEmpty(this.header.Sekolah);
    },
    isTahunEmpty() {
      return this.$util.isEmpty(this.header.Tahun);
    },
    isStatusAnggaranEmpty() {
      return this.$util.isEmpty(this.header.StatusAnggaran);
    },
    isPejabatSekolahEmpty() {
      return this.$util.isEmpty(this.header.PejabatSekolah);
    },
    lastUpdatedDatePenerimaan() {
      return this.getLastUpdatedDate("penerimaan");
    },
    lastUpdatedDateBelanja() {
      return this.getLastUpdatedDate("belanja");
    },
    totalPenerimaan() {
      return this.getSummary("penerimaan");
    },
    totalBelanja() {
      return this.getSummary("belanja");
    },
    terkunci() {
      return this.header && !!this.header.ETLID;
    },
    formattedDate() {
      return this.$format.date(this.header.Tanggal);
    }
  },
  methods: {
    ...mapActions("list", [
      "refreshProgram",
      "refreshSekolah",
      "refreshRekening",
      "refreshTahun",
      "refreshStatusAnggaran",
      "refreshPejabat"
    ]),
    async save() {
      let param = { ...this.header };

      param.Tanggal = new Date(param.Tanggal);
      param.NominalBelanja = this.getSummary("belanja");
      param.NominalPenerimaan = this.getSummary("penerimaan");
      param.Detail = this.details;

      const valid = await this.$refs.header.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/report/rkas", param)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.clearDetailCache();
          this.$router.push("/laporan/rkas");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah RKAS" : "RKAS Baru";
    },
    getLastUpdatedDate(jenis = "belanja") {
      if (this.details.length == 0) return;

      let result = this.details.filter(x => x.Jenis == jenis);
      if (!result) return;

      result = result.sort((a, b) => {
        let paramA = a.LastUpdatedDate || a.CreatedDate;
        let paramB = b.LastUpdatedDate || b.CreatedDate;

        if (paramA > paramB) return 1;
        return -1;
      })[0];

      if (!result) return;

      return result.LastUpdatedDate || result.CreatedDate;
    },
    getSummary(jenis = "belanja") {
      return sumBy(
        this.details.filter(x => x.Jenis == jenis),
        x => {
          return x.Pagu;
        }
      );
    },
    checkEditingStatus() {
      this.isEditingSekolah = this.isSekolahEmpty;
      this.isEditingRekening = this.isRekeningEmpty;
      this.isEditingTahun = this.isTahunEmpty;
      this.isEditingStatusAnggaran = this.isStatusAnggaranEmpty;
      this.isEditingPejabatSekolah = this.isPejabatSekolahEmpty;
    },
    checkExist() {
      // this.saving = true;
      // this.$axios
      //   .post("/report/rkas/check_exist", {
      //     IDSekolah: this.header.IDSekolah,
      //     Tahun: this.header.Tahun,
      //     StatusAnggaran: this.header.StatusAnggaran
      //   })
      //   .then(res => {
      //     this.disabledSimpan = res.data.Data.Exist;
      //   })
      //   .catch(error => {
      //     this.$dialog.notify.error(error, {
      //       ...this.app.notification
      //     });
      //   })
      //   .finally(() => {
      //     this.saving = false;
      //   });
    },
    storeDetailCache(detail) {
      let key = `rkas_cache_${this.header.IDSekolah}`;
      if (detail && detail.length > 0) {
        localStorage.setItem(key, JSON.stringify(detail));
      }
    },
    loadDetailCache() {
      this.cacheExists = false;
      let key = `rkas_cache_${this.header.IDSekolah}`;
      let cache = localStorage.getItem(key);
      if (cache) {
        try {
          let result = JSON.parse(cache);
          this.cacheExists = Array.isArray(result) && result.length > 0;
          return result;
        } catch (error) {
          console.warn("error while parsing cache", key);
          return undefined;
        }
      }
    },
    clearDetailCache() {
      let key = `rkas_cache_${this.header.IDSekolah}`;
      localStorage.removeItem(key);
      this.loadDetailCache();
    },
    async clearDetailCacheWithConfirm() {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda ingin membersihkan cache?"
      });
      if (!confirmation) return;
      this.clearDetailCache();
      // load cache
      this.loadDetailCache();
      this.details = [];
    }
  },
  created() {},
  async mounted() {
    this.refreshTahun();
    this.refreshRekening({
      type: "transaction"
    });

    let id = this.$route.params.id;
    let user = this.$session.get.user();
    let isUserSekolah = this.$acl.check("isSekolah") && !!user.idSekolah;
    if (!isUserSekolah) this.refreshSekolah();
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/report/rkas/${id}`)
        .then(res => {
          let result = res.data.Data;

          this.header = result;
          this.details = result.Detail.map(x => {
            x.uid = this.$util.uid();
            x.Jenis = x.TipeAnggaran == "RKA1" ? "penerimaan" : "belanja";
            return x;
          });

          this.loading = false;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.checkEditingStatus();
        });
    } else {
      // set current status anggaran into form
      this.loading = true;
      this.$axios
        .post(`/administration/status_anggaran/current`, {})
        .then(async res => {
          let data = res.data.Data;
          this.header.Tahun = data.Tahun;
          this.header.StatusAnggaran = data.StatusAnggaran;

          // checking editing status
          this.isEditingTahun = this.isTahunEmpty;
          this.isEditingStatusAnggaran = this.isStatusAnggaranEmpty;

          // if logged user is user sekolah
          // then assign its user as default
          if (user.idSekolah) {
            let filter = new this.$dbflex();
            filter.eq("IDSekolah", user.idSekolah);

            try {
              let res = await this.$axios.post(`/administration/sekolah/list`, {
                Filter: filter.get()
              });

              let data = res.data.Data;
              if (data && data.length > 0) {
                this.header.IDSekolah = user.idSekolah;
                this.header.Sekolah = data[0];
              }
              this.checkExist();
            } catch (error) {
              this.$dialog.notify.error(error, {
                ...this.app.notification
              });
            } finally {
              this.checkEditingStatus();
            }
          } else {
            this.checkEditingStatus();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    "header.Sekolah"(v) {
      if (!this.$util.isEmpty(v)) {
        this.header.IDSekolah = v.IDSekolah;
        let id = this.$route.params.id;
        if (!id) {
          // load cache
          let details = this.loadDetailCache();
          if (details && details.length > 0) this.details = details;
          else this.details = [];
        }
        this.refreshPejabat({
          type: "sekolah",
          param: { idSekolah: v.IDSekolah }
        });
        this.refreshProgram(v.IDBidang);
        if (this.header.Tahun && this.header.StatusAnggaran != "") {
          this.checkExist();
        }
      }
    },

    "header.Tahun"(v) {
      if (!this.$util.isEmpty(v)) {
        this.refreshStatusAnggaran(v);
        if (this.header.IDSekolah != "") {
          this.checkExist();
        }
      }
    },
    "header.StatusAnggaran"(v) {
      if (!this.$util.isEmpty(v) && this.header.IDSekolah != "") {
        this.checkExist();
      }
    },
    "header.Rekening"(v) {
      if (!this.$util.isEmpty(v)) this.header.IDRekening = v.IDRekening;
    },
    "header.PejabatSekolah"(v) {
      if (!this.$util.isEmpty(v)) this.header.IDPejabatSekolah = v.IDPejabat;
    },
    details(v, vOld) {
      let id = this.$route.params.id;
      if (!id) {
        // store added details to cache
        if (v && v.length > 0) this.storeDetailCache(v);
        if (vOld.length > 0 && v.length == 0) this.clearDetailCache();
      }
    }
  }
};
</script>

<style>
</style>